const data = {
    aboutDescription1: 'Welcome to the world of WhiteBones, our brand can be described by 3 words: CREATIVITY, FREEDOM, AND COMMUNITY.',
    aboutDescription2: "Among the WhiteBones, we believe in the power of games and imagination. We are here to help you unlock your creativeness and competitive nature! Boneys are cute and goofy looking but don’t let their looks fool you! They are mighty, fast and very very special. It's a matter of time till you become emotionally connected to your very own Boney!",
}

export default data;